module.exports = __webpack_public_path__ + "h5/img/test03.8c2280ee.jpg";